export default __webpack_public_path__ + "static/captainminer-a0eafa7809548c68d0bd9b94a669e08a.png";